import React, { Component } from 'react';
import _ from 'lodash';
import {
    getPendingPayoutBatches as fetchPayoutBatches,
    fetchUrl
} from '../PayoutBatches/payoutBatchesActions';
import {
    getPayoutBatches,
    getCount,
    getPages,
    getPayoutBatchesErrorMessage,
    getIsPayoutBatchesLoading,
    getHasMore
} from '../PayoutBatches/payoutBatchesEntity';
import { transformDateCell } from '../../utils/cell';
import Table from '../Table/Table';
import { dataTransform } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';
import { selectPayoutBatch } from '../PayoutBatches/payoutBatchesActions';
import { getSelectedPayoutAccountIdsString } from '../PayoutAccountSelector/payoutAccountSelectorViewState';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { getColumnsByUniqueTableName } from '../Table/tableEntity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getCustomAccess } from '../Self/selfEntity';
import { toggleModal } from '../Modal/modalActions';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';
import PayoutBatchListItem from '../PayoutBatches/PayoutBatchListItem/PayoutBatchListItem';
import '../PayoutBatches/PayoutBatches.scss';
import FilterWithMapper from '../Table/Filters/FilterWithMapper/FilterWithMapper';

export class PendingPayoutBatches extends Component {
    dateKey = 'updatedAt';

    static propTypes = {
        selectedPayoutAccountIds: PropTypes.string,
        onToggleModal: PropTypes.func.isRequired,
        columns: PropTypes.array,
        payoutAccountMap: PropTypes.any,
        timezone: PropTypes.string,
        customAccess: PropTypes.any,
        isAdmin: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'payoutAccountId',
                transformData: (data) => `${data.original.payoutAccountId} - ${this.props.payoutAccountMap[data.original.payoutAccountId]}`,
                filterable: true,
                Filter: ({ filter, onChange }) => (
                    <FilterWithMapper filter={filter}
                        mapper={this.getPayoutAccountsDropDown()}
                        onChange={onChange}
                    />
                ),
                className: ['cursor-pointer'],
                label: 'Payout Account',
                minWidth: 250,
                show: true,
                sortable: true
            },
            {
                accessor: 'batchRef',
                className: ['cursor-pointer'],
                label: 'Batch Ref',
                minWidth: 250,
                show: true,
                filterable: true,
                sortable: true
            },
            {
                accessor: 'initialBatchDate',
                Cell: transformDateCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Initial Batch Date',
                minWidth: 185,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'updatedAt',
                Cell: transformDateCell,
                filterable: false,
                className: ['cursor-pointer'],
                label: 'Last Updated At',
                minWidth: 185,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'payoutCount',
                className: ['cursor-pointer'],
                label: 'Payout Count',
                minWidth: 105,
                show: true,
                filterable: false,
                sortable: false
            },
            {
                accessor: 'badPayoutRequestCount',
                className: ['cursor-pointer'],
                label: 'Errored Request Payout Count',
                minWidth: 200,
                show: true,
                filterable: false,
                sortable: false
            }
        ];
    }

    renderHeaderComponent = () => {
        return (
            <div className="payout-table-header">
                {this.props.isAdmin ? <span className="material-icons" title="Upload Payout Batch" onClick={() => this.props.onToggleModal('uploadPayouts')}>upload_file</span> : null}
            </div>
        );
    };

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    getPayoutAccountsDropDown = () => {
        const result = {};
        _.forEach(this.props.payoutAccountMap, (value, key) => {
            result[key] = `${key} - ${value}`;
        });

        return result;
    };

    render() {
        return (
            <div className="emvio-payout-batches">
                <Table
                    fetchUrl={fetchUrl}
                    className="emvio-payout-batches-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: this.dateKey
                    }]}
                    fetchData={(filters, page, pageSize, sorters, merchantIds, columns) => fetchPayoutBatches(filters, page, pageSize, sorters, this.props.selectedPayoutAccountIds, columns)}
                    countSelector={getCount}
                    dataSelector={getPayoutBatches}
                    selectRow={selectPayoutBatch}
                    errorMessageSelector={getPayoutBatchesErrorMessage}
                    isDataLoadingSelector={getIsPayoutBatchesLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    hasNoCount={true}
                    HeaderComponent={this.renderHeaderComponent}
                    hasMoreSelector={getHasMore}
                    ListItemComponent={PayoutBatchListItem}
                    noDataText="No Pending Payout Batches To Review"
                    uniqueTableName="PendingPayoutBatches"
                    getTableState={this.getTableState}
                    filterable={true}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'PendingPayoutBatches'),
        payoutAccountMap: getPayoutAccountsMapper(state),
        customAccess: getCustomAccess(state),
        isAdmin: getIsUserAnAdmin(state)
    };
}

function mapDispatchToProps(dispatch) {
    return { onToggleModal: () => dispatch(toggleModal('uploadPayouts')) };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PendingPayoutBatches));
